import { useMutation, useQuery } from '@tanstack/react-query';
import { getPreRegistrationInfo, preRegistration } from '../Services/register';
import { useState } from 'react';
import { BtnStatus } from '../../../../../Js/React/UI/BizButton/BizButton';
import { ResponseStatus } from '../../../../../FrontEndReact/src/Core/Types/base';

const QUERYKEY_PREREGISTRATIONINFO = 'PREREGISTRATIONINFO';

export const useGetPreRegisterInfo = () => {
	const [btnStatus, setBtnStatus] = useState<BtnStatus>('INITIAL');
	const [email, setEmail] = useState('');
	const [enabled, setEnabled] = useState(false);
	const { data, refetch } = useQuery({
		queryKey: [QUERYKEY_PREREGISTRATIONINFO, email],
		queryFn: async () => {
			setBtnStatus('SAVING');
			const data = await getPreRegistrationInfo(email);
			setBtnStatus('SAVED');
			return data;
		},
		enabled,
	});

	const getInfo = (email: string) => {
		setEmail(email);
		if (!enabled) {
			setEnabled(true);
		} else {
			refetch();
		}
	};

	return {
		data,
		btnStatus,
		getPreRegistrationInfo: getInfo,
	};
};

export const usePreRegistration = () => {
	const [result, setResult] = useState<ResponseStatus | null>(null);
	const [btnStatus, setBtnStatus] = useState<BtnStatus>('INITIAL');

	const performPreRegistration = useMutation({
		mutationFn: (options: { email: string; unitId: number }) => {
			return preRegistration(options.email, options.unitId);
		},
		onMutate: () => {
			setBtnStatus('SAVING');
		},
		onSuccess: (response) => {
			setResult(response ?? null);
			setBtnStatus('SAVED');
		},
		onError: (err) => {
			console.log('error', err);
			setBtnStatus('ERROR');
		},
	});

	return {
		result,
		btnStatus,
		preRegistration: (email: string, unitId: number) => performPreRegistration.mutate({ email, unitId }),
		clear: () => setResult(null),
	};
};
